export enum BUILD_ENVIRONMENT {
	'development' = 'development',
	'production' = 'production',
	'staging' = 'staging',
}
